/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelfReportUnderageBody
 */
export interface SelfReportUnderageBody {
    /**
     * Unix milliseconds. Must resolve to an age under 18.
     * @type {number}
     * @memberof SelfReportUnderageBody
     */
    dateOfBirth: number;
}

/**
 * Check if a given object implements the SelfReportUnderageBody interface.
 */
export function instanceOfSelfReportUnderageBody(value: object): value is SelfReportUnderageBody {
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    return true;
}

export function SelfReportUnderageBodyFromJSON(json: any): SelfReportUnderageBody {
    return SelfReportUnderageBodyFromJSONTyped(json, false);
}

export function SelfReportUnderageBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelfReportUnderageBody {
    if (json == null) {
        return json;
    }
    return {
        
        'dateOfBirth': json['dateOfBirth'],
    };
}

export function SelfReportUnderageBodyToJSON(json: any): SelfReportUnderageBody {
    return SelfReportUnderageBodyToJSONTyped(json, false);
}

export function SelfReportUnderageBodyToJSONTyped(value?: SelfReportUnderageBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateOfBirth': value['dateOfBirth'],
    };
}

